module.exports = __webpack_public_path__ + "static/images/step6.bca3092.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step6.png
// module id = iTrA
// module chunks = 1